<div class="columns" *ngIf="autocompleteResults.length !== 0">
  <small *ngFor="let name of columnNames">{{ name }}</small>
</div>
<mat-option
  id="genericAutoCompleteResults-matOption-{{ result[testingIdAccessor]?.toString() | camelCase }}"
  class="generic-autocomplete"
  *ngFor="let result of autocompleteResults"
  (click)="selectAutocompleteResult(result)"
>
  <span *ngFor="let group of displayedFields">
    <span *ngFor="let path of group">{{ idx(path, result)?.toString() }}&nbsp;</span>
  </span>
</mat-option>
